import tippy from 'tippy.js'

class TooltipWrapper extends window.HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button')

    // Opt-in: dismiss on outside click and on page scroll. Defaults preserve the
    // original behaviour so existing tooltips (price, reviews) are unaffected.
    const dismissOnInteract = this.getAttribute('data-hide-on-click') === 'true'
    let onScroll = null

    const instance = tippy(button, {
      placement: this.getAttribute('data-placement') || 'top',
      theme: this.getAttribute('data-dark-mode') === 'true' ? 'dark' : '',
      interactive: true,
      content: `${this.getAttribute('data-content')}`,
      allowHTML: true,
      trigger: 'mouseenter click',
      hideOnClick: dismissOnInteract ? true : 'toggle',
      ...(dismissOnInteract && {
        onShow: () => {
          onScroll = () => instance.hide()
          window.addEventListener('scroll', onScroll, { passive: true })
        },
        onHide: () => {
          window.removeEventListener('scroll', onScroll, { passive: true })
        },
      }),
    })
  }
}

window.customElements.define('tooltip-wrapper', TooltipWrapper)
